<div>
    <div class="mat-elevation-z8">
        <div class="p-3 pb-0">
            <h2 class="montserrat-medium text-gray-500 mb-0">{{ supplierName }}</h2>
            <h6 class="text-gray p-0 mt-1">Individual MF Charges Breakdown</h6>
        </div>
        <div class="tableHolder table-responsive p-3 table-container-scrollable">
            <table mat-table [dataSource]="dataSource" matSort matSortDirection="asc" class="table">
                <!-- transactionType -->
                <ng-container matColumnDef="transactionType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Transaction Type</th>
                    <td mat-cell *matCellDef="let element">
                        {{ formatTransactionType(element.transactionType) }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef class="total-label">Total</td>
                </ng-container>

                <!-- amount -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.amount.value | currency: element.amount.currencyCode }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                        {{ supplierTotalCharge?.value | currency: supplierTotalCharge?.currencyCode }}
                    </td>
                </ng-container>

                <!-- createdAt -->
                <ng-container matColumnDef="createdAt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Added</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.createdAt }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columns"></tr>
                <tr mat-row *matRowDef="let row; columns: columns"></tr>
                <tr mat-footer-row *matFooterRowDef="columns"></tr>
            </table>
        </div>
    </div>
</div>